
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ProfessionalDirectory() {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedField, setSelectedField] = useState('all');

  const professionals = [
    {
      name: 'Dr. Ayşe Yılmaz',
      field: 'education',
      title: 'Eğitim Politikaları Uzmanı',
      location: 'İstanbul, Türkiye',
      image: 'https://public.readdy.ai/ai/img_res/1548a8427065fab22440a11346b36e3a.jpg',
    },
    {
      name: 'Prof. Mehmet Demir',
      field: 'healthcare',
      title: 'Kardiyoloji Profesörü',
      location: 'Ankara, Türkiye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20distinguished%20Turkish%20male%20cardiologist%20in%20his%2050s%2C%20wearing%20white%20medical%20coat%20over%20business%20attire%2C%20standing%20in%20a%20modern%20hospital%20setting.%20Confident%20and%20caring%20expression%2C%20professional%20medical%20photography%20style%2C%20clean%20background%20with%20subtle%20medical%20equipment%2C%20emphasizing%20trust%20and%20expertise&width=400&height=400&seq=prof-mehmet-002&orientation=squarish',
    },
    {
      name: 'Eng. Fatma Öztürk',
      field: 'technology',
      title: 'Yazılım Mimarı',
      location: 'İzmir, Türkiye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20modern%20Turkish%20female%20software%20architect%20in%20her%2030s%2C%20wearing%20smart%20casual%20business%20attire%2C%20standing%20in%20a%20contemporary%20tech%20office%20with%20minimalist%20design.%20Confident%20and%20innovative%20expression%2C%20professional%20corporate%20photography%20style%2C%20clean%20background%20with%20subtle%20technology%20elements%2C%20emphasizing%20expertise%20and%20forward-thinking%20approach&width=400&height=400&seq=prof-fatma-003&orientation=squarish',
    },
    {
      name: 'Dr. Ali Kaya',
      field: 'business',
      title: 'Ekonomi ve Finans Danışmanı',
      location: 'Bursa, Türkiye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20sophisticated%20Turkish%20male%20financial%20consultant%20in%20his%2040s%2C%20wearing%20elegant%20dark%20business%20suit%20with%20tie%2C%20standing%20in%20a%20modern%20corporate%20office%20with%20city%20skyline%20view.%20Confident%20and%20trustworthy%20expression%2C%20executive%20photography%20style%2C%20clean%20background%20emphasizing%20professionalism%20and%20business%20acumen&width=400&height=400&seq=prof-ali-004&orientation=squarish',
    },
    {
      name: 'Av. Zeynep Arslan',
      field: 'law',
      title: 'Uluslararası Hukuk Uzmanı',
      location: 'Antalya, Türkiye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20elegant%20Turkish%20female%20international%20law%20expert%20in%20her%2040s%2C%20wearing%20sophisticated%20business%20suit%2C%20standing%20in%20a%20prestigious%20law%20office%20with%20legal%20books%20in%20background.%20Confident%20and%20authoritative%20expression%2C%20professional%20legal%20photography%20style%2C%20clean%20background%20emphasizing%20expertise%20and%20credibility&width=400&height=400&seq=prof-zeynep-005&orientation=squarish',
    },
    {
      name: 'Müh. Hasan Çelik',
      field: 'engineering',
      title: 'İnşaat Mühendisi',
      location: 'Konya, Türkiye',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20Turkish%20male%20civil%20engineer%20in%20his%2040s%2C%20wearing%20business%20casual%20attire%20with%20safety%20vest%2C%20standing%20at%20a%20modern%20construction%20site%20with%20architectural%20plans.%20Professional%20and%20competent%20expression%2C%20engineering%20photography%20style%2C%20clean%20background%20with%20subtle%20construction%20elements%2C%20emphasizing%20technical%20expertise%20and%20reliability&width=400&height=400&seq=prof-hasan-006&orientation=squarish',
    },
  ];

  const fields = [
    { value: 'all', label: t('directory.filter.all') },
    { value: 'education', label: t('directory.filter.education') },
    { value: 'healthcare', label: t('directory.filter.healthcare') },
    { value: 'technology', label: t('directory.filter.technology') },
    { value: 'business', label: t('directory.filter.business') },
    { value: 'law', label: t('directory.filter.law') },
    { value: 'engineering', label: t('directory.filter.engineering') },
  ];

  const filteredProfessionals = professionals.filter((prof) => {
    const matchesSearch = prof.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         prof.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesField = selectedField === 'all' || prof.field === selectedField;
    return matchesSearch && matchesField;
  });

  return (
    <section id="directory" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-4">
            {t('directory.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('directory.subtitle')}
          </p>
        </div>

        {/* Search and Filter */}
        <div className="mb-12 flex flex-col md:flex-row gap-4">
          <div className="flex-1 relative">
            <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
            <input
              type="text"
              placeholder={t('directory.search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] text-sm"
            />
          </div>
          <select
            value={selectedField}
            onChange={(e) => setSelectedField(e.target.value)}
            className="px-6 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] bg-white cursor-pointer text-sm"
          >
            {fields.map((field) => (
              <option key={field.value} value={field.value}>
                {field.label}
              </option>
            ))}
          </select>
        </div>

        {/* Professional Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProfessionals.map((prof, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
            >
              <div className="w-full h-64">
                <img
                  src={prof.image}
                  alt={prof.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1A2332] mb-2">{prof.name}</h3>
                <p className="text-[#C9A961] font-semibold mb-2">{prof.title}</p>
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span className="text-sm">{prof.location}</span>
                </div>
                <button className="w-full px-4 py-2 bg-[#1A2332] text-white rounded-lg hover:bg-[#2A3342] transition-colors text-sm font-semibold whitespace-nowrap cursor-pointer">
                  {t('directory.viewProfile')}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
